import nl from './nl';
import en from './en';

export default {
  nl,
  en,
};
